const initSubmitValidation = (section) => {
    const nameInput = section.querySelector('.js-first-name-input');
    const surnameInput = section.querySelector('.js-surname-input');
    const emailInput = section.querySelector('.js-email-input');
    const countrySelect = section.querySelector('.js-country-input');
    const acceptTermsInput = section.querySelector('.js-terms-input');
    const submitButton = section.querySelector('.js-submit-memory');

    let hasErrors = true;

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

    const validateForm = () => {
        const nameFilled = nameInput.value.trim() !== '';
        const surnameFilled = surnameInput.value.trim() !== '';
        const emailValid = emailInput.value.trim() !== '' && isValidEmail(emailInput.value);
        const countryValid = countrySelect.value !== 'country';
        const termsChecked = acceptTermsInput.checked;

        hasErrors = !(nameFilled && surnameFilled && emailValid && countryValid && termsChecked);

        submitButton.classList.toggle('inactive', hasErrors);
    };

    [nameInput, surnameInput, emailInput, countrySelect, acceptTermsInput].forEach((field) => {
        const event = field.type === 'checkbox' ? 'change' : 'input';
        field.addEventListener(event, validateForm);
    });
};

export default initSubmitValidation;
